<template>
  <iframe
    id="hospitalSearch"
    width="100%"
    height="500px"
    referrerpolicy="strict-origin"
    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    title="hospitalSearch"
    :src="hospitalSearchUrl"
  />
</template>

<script setup>
  import { computed } from 'vue'

  import useI18n from '@shared/hooks/useI18n'

  // HOOKS
  const { t } = useI18n()

  // INIT
  const props = defineProps({
    productId: {
      type: String,
      required: true,
    },
  })

  // COMPUTED
  const hospitalSearchUrl = computed(() => {
    return `${import.meta.env.VITE_SANITAS_COM_PATH}/${t(`products.${props.productId}.hospitalSearchUrl`)}`
  })
</script>

<style scoped>
#benefitsOverview,
#hospitalSearch {
  border: none;
}
</style>
